export default "__VITE_ASSET__COSRYqD0__"